import React, { useMemo } from 'react';
import './style.css';
import dayjs from 'dayjs';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { EventFractional } from '@/model/EventFractional';

interface Props {
  ticketsFractional: EventFractional[];
}

export const EventFractionalReportUI: React.FC<Props> = ({ ticketsFractional }) => {
  const normalize = (n: number, min: number, max: number): number =>
    Math.min(max, Math.max(min, n));

  const sorted = useMemo(
    () =>
      [...ticketsFractional].sort((a, b) => {
        const da = a.orderDate ? new Date(a.orderDate).getTime() : 0;
        const db = b.orderDate ? new Date(b.orderDate).getTime() : 0;
        return db - da;
      }),
    [ticketsFractional],
  );

  if (!sorted.length) {
    return <div className="efr-empty">Nenhum pedido fracionado encontrado.</div>;
  }

  return (
    <div className="efr-wrapper">
      {sorted.map(order => {
        const total = order.totalValue ?? 0;
        const paid = order.paidAmount ?? 0;
        const remaining = order.remainingValue ?? Math.max(0, total - paid);
        const base = total > 0 ? total : 1;
        const paidPct = normalize((paid / base) * 100, 0, 100);
        const itemLabel = order.items?.[0]?.itemLabel ?? 'Ingresso';

        return (
          <div key={order.orderId} className="efr-row">
            <div className="efr-row-header">
              <div className="efr-col efr-col-title">
                <strong>{itemLabel}</strong>
                <span className="efr-muted">
                  {dayjs(order.orderDate).format('DD/MM/YYYY')} • POS {order.serialNumber ?? '-'}
                </span>
              </div>

              <div className="efr-col">
                <span>Total</span>
                <strong>{toCurrency(total)}</strong>
              </div>

              <div className="efr-col">
                <span>Pago</span>
                <strong>{toCurrency(paid)}</strong>
              </div>

              <div className="efr-col">
                <span>Falta</span>
                <strong>{toCurrency(remaining)}</strong>
              </div>
            </div>

            {/* Barra de progresso */}
            <div className="efr-progress">
              <div className="efr-progress-bar">
                <div className="efr-progress-fill" style={{ width: `${paidPct}%` }} />
              </div>
              <div className="efr-progress-label">{paidPct.toFixed(0)}% pago</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
